import {
  RULE_ACTIONS,
  RULE_TYPES,
  GEOGRAPHIC_CRITERIA_TYPES,
  GEOGRAPHIC_DIRECTIONS,
  MILEAGE_BUCKETS,
  DATE_TYPES,
} from '../types/shipperStrikePrices'

export const ORDERED_REGIONS = ['Northeast', 'Southeast', 'South', 'Coastal', 'West', 'Midwest']

export const regionOptions = ORDERED_REGIONS.map(region => ({
  value: region,
  label: region,
}))

export const ruleActionOptions = [
  {
    value: RULE_ACTIONS.APPLY_PREMIUM,
    label: 'Apply Premium',
  },
  {
    value: RULE_ACTIONS.DONT_BID,
    label: "Don't Bid",
  },
]

export const ruleTypeOptions = [
  {
    value: RULE_TYPES.GEOGRAPHIC,
    label: 'Geographic',
  },
  {
    value: RULE_TYPES.TIME,
    label: 'Time',
  },
  {
    value: RULE_TYPES.MILEAGE,
    label: 'Mileage',
  },
  {
    value: RULE_TYPES.EQUIPMENT,
    label: 'Equipment',
  },
  {
    value: RULE_TYPES.LANE,
    label: 'Lane',
  },
  {
    value: RULE_TYPES.STEP_PRICING,
    label: 'Step Pricing',
  },
]

export const geoTypeOptions = [
  {
    value: GEOGRAPHIC_CRITERIA_TYPES.REGION,
    label: 'Region',
  },
  {
    value: GEOGRAPHIC_CRITERIA_TYPES.STATE,
    label: 'State',
  },
  {
    value: GEOGRAPHIC_CRITERIA_TYPES.CITY_STATE,
    label: 'City, State',
  },
  {
    value: GEOGRAPHIC_CRITERIA_TYPES.DAT_MARKET,
    label: 'DAT Market',
  },
]

export const geoDirectionOptions = [
  {
    value: GEOGRAPHIC_DIRECTIONS.OUTBOUND,
    label: 'Outbound (PU)',
  },
  {
    value: GEOGRAPHIC_DIRECTIONS.INBOUND,
    label: 'Inbound (DEL)',
  },
]

export const dateGeoOptions = [
  {
    value: DATE_TYPES.DATE_RANGE,
    label: 'Date Range',
  },
  {
    value: DATE_TYPES.NUMBER_OF_DAYS_OUT,
    label: 'Number of Days Out',
  },
]

export const dateOnlyOptions = [
  {
    value: DATE_TYPES.DATE_RANGE,
    label: 'Date Range',
  },
  {
    value: DATE_TYPES.NUMBER_OF_DAYS_OUT,
    label: 'Number of Hours/Days Out',
  },
  {
    value: DATE_TYPES.WEEKEND,
    label: 'Weekend',
  },
  {
    value: DATE_TYPES.SAME_DAY,
    label: 'Same Day',
  },
  {
    value: DATE_TYPES.NEXT_DAY,
    label: 'Next Day',
  },
]

export const mileageBucketOptions = [
  {
    value: MILEAGE_BUCKETS.CITY,
    label: 'City - 0-100 Miles',
  },
  {
    value: MILEAGE_BUCKETS.SHORT,
    label: 'Short - 100-250 Miles',
  },
  {
    value: MILEAGE_BUCKETS.MID,
    label: 'Mid - 250-450 Miles',
  },
  {
    value: MILEAGE_BUCKETS.TWEENER,
    label: 'Tweener - 450-800 Miles',
  },
  {
    value: MILEAGE_BUCKETS.LONG,
    label: 'Long-Haul - 800-1700 Miles',
  },
  {
    value: MILEAGE_BUCKETS.CROSSCOUNTRY,
    label: 'Cross-Country - 1700+ Miles',
  },
]

export const MILEAGE_CITY_MIN = 0
export const MILEAGE_CITY_MAX = 100

export const MILEAGE_SHORT_MIN = 100
export const MILEAGE_SHORT_MAX = 250

export const MILEAGE_MID_MIN = 250
export const MILEAGE_MID_MAX = 450

export const MILEAGE_TWEENER_MIN = 450
export const MILEAGE_TWEENER_MAX = 800

export const MILEAGE_LONG_MIN = 800
export const MILEAGE_LONG_MAX = 1700

export const MILEAGE_CROSSCOUNTRY_MIN = 1700
